"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tiers = [{
  id: 1,
  title: "The Intimate Soiree",
  price: "Starting at $5,000",
  description: "A refined approach for private dinners, micro-weddings, and exclusive gatherings requiring meticulous attention to detail."
}, {
  id: 2,
  title: "The Signature Celebration",
  price: "Starting at $12,000",
  description: "Comprehensive planning and sophisticated design for weddings and milestone events, ensuring a seamless and unforgettable experience."
}, {
  id: 3,
  title: "The Echelon Experience",
  price: "Custom Quoted",
  description: "Full-scale production and logistics management for corporate galas, multi-day affairs, and high-profile brand activations."
}];
const inclusions = [{
  tierId: 1,
  text: "Venue Selection & Scouting"
}, {
  tierId: 1,
  text: "Bespoke Décor Styling"
}, {
  tierId: 1,
  text: "Vendor Curation (Up to 3)"
}, {
  tierId: 1,
  text: "Day-of Coordination"
}, {
  tierId: 1,
  text: "Customized Timeline Creation"
}, {
  tierId: 1,
  text: "Intimate Guest Management"
}, {
  tierId: 2,
  text: "Comprehensive Venue Management"
}, {
  tierId: 2,
  text: "Full-Scale Design Concept"
}, {
  tierId: 2,
  text: "Unlimited Vendor Sourcing"
}, {
  tierId: 2,
  text: "Budget & Timeline Management"
}, {
  tierId: 2,
  text: "Rehearsal Coordination"
}, {
  tierId: 2,
  text: "Complete On-site Execution"
}, {
  tierId: 3,
  text: "Multi-day Event Logistics"
}, {
  tierId: 3,
  text: "Custom Fabrication & Staging"
}, {
  tierId: 3,
  text: "Headline Entertainment Booking"
}, {
  tierId: 3,
  text: "VIP Guest Management"
}, {
  tierId: 3,
  text: "Travel & Accommodation Coordination"
}, {
  tierId: 3,
  text: "Dedicated Production Team"
}];
function TierCard({
  tier,
  index
}: {
  tier: typeof tiers[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const tierInclusions = inclusions.filter(inc => inc.tierId === tier.id);
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      <Card className="flex flex-col lg:flex-row gap-0 p-0 overflow-hidden border-border rounded-none shadow-none border bg-card">
        <div className="w-full lg:w-2/5 p-8 lg:p-12 bg-muted/30 border-b lg:border-b-0 lg:border-r border-border flex flex-col justify-center">
          <span className="text-sm tracking-widest uppercase text-muted-foreground mb-6 block font-sans">
            {tier.price}
          </span>
          <h3 className="font-serif text-[40px] leading-tight text-foreground mb-6">
            {tier.title}
          </h3>
          <p className="text-muted-foreground font-light font-sans leading-relaxed">
            {tier.description}
          </p>
        </div>
        
        <div className="w-full lg:w-3/5 p-8 lg:p-12 flex flex-col justify-between">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5 mb-12">
            {tierInclusions.map((inc, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                <Check className="w-4 h-4 mt-1 text-foreground/30 shrink-0" />
                <span className="font-sans font-light text-foreground/80 text-sm md:text-base">
                  {inc.text}
                </span>
              </li>)}
          </ul>
          
          <div className="mt-auto">
            <Button asChild size="lg" className="rounded-none px-8 tracking-wide uppercase text-xs h-12">
              <Link to="/InquirePage">Select This Curation</Link>
            </Button>
          </div>
        </div>
      </Card>
    </div>;
}
export default function ServiceTiers() {
  return <section id="service-tiers" className="bg-background py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-20 max-w-2xl">
          <h2 className="font-serif text-4xl md:text-5xl text-foreground mb-6 tracking-tight">
            Curated Experiences
          </h2>
          <p className="text-muted-foreground font-light text-lg md:text-xl leading-relaxed font-sans">
            Discover our tailored service tiers, designed to provide meticulous coordination and sophisticated design for your most significant celebrations.
          </p>
        </div>
        
        <div className="flex flex-col gap-12">
          {tiers.map((tier, index) => <TierCard key={tier.id} tier={tier} index={index} />)}
        </div>
      </div>
    </section>;
}